(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    // task overview controller
    module.controller('TasksOverviewController',
        ['$scope', '$state', '$filter', '$stateParams', 'SharedAgendaService', 'SharedAgendaBroadcast','DownloadService', 'ExportFormat', 'TaskService', 'TaskListService', 'tasks', 'title', TasksOverviewControllerFn]);

    function TasksOverviewControllerFn($scope, $state, $filter, $stateParams, SharedAgendaService, SharedAgendaBroadcast,DownloadService, ExportFormat, TaskService, TaskListService, tasks, title) {
        //// metronic init 
        //$scope.$on('$viewContentLoaded', function () {
        //    App.initAjax(); // initialize core components
        //});
        /* jshint validthis:true */
        var vm = this;

        // view header title
        vm.title = null;
        // overview service
        vm.overview = null;
        // pre-selected states
        vm.preSelectedStates = [];
        vm.taskId = null;
        // is to do 
        vm.isToDo = false; // default
        // service
        var service = null;

        activate();


        /* show detail view for creating new one */
        vm.new = function () {
            TaskService.newTask($stateParams.isToDo);
        };

        /* show all tasks (includes deactivated ones) */
        vm.showAll = function () {
            refresh();
        };


        /* reset pre-selected task id */
        vm.clearTaskId = function () {
            $state.go($state.current.name, { isToDo: $stateParams.isToDo, all: vm.overview.data.showAll, states: null, taskId: null }, { reload: $state.current.name });
        };

        /* export task list */
        vm.export = function () {
            var filteredTasks = vm.overview.data.results;
            if (vm.taskId > 0) {
                filteredTasks = $filter('filter')(vm.overview.data.results, { 'id': vm.taskId });
            }

            var taskIds = [];
            for (var i = 0; i < filteredTasks.length; i++) {
                taskIds.push(filteredTasks[i].id);
            }

            if (taskIds.length > 0) {
                DownloadService.exportFilteredTasks(ExportFormat.CSV.value, SharedAgendaService.currentUser().id, taskIds).then(function (response) {
                    DownloadService.openReport(ExportFormat.CSV.value, response, "tasks");
                });
            }
        };


        /* activation work */
        function activate() {
            // is to do
            vm.isToDo = $stateParams.isToDo;
            // allow shared agendas only for Daytasks
            if (vm.isToDo === 'true') {
                SharedAgendaService.block();
            } // if
            else {
                SharedAgendaService.allow();
            } // else

            // attribute set
            vm.title = title;

            // init service
            service = new TaskListService();
            service.init(tasks, [SharedAgendaService.data.currentAgenda.id], $stateParams.isToDo);


            // states preselect (fe comes from message-controller)
            if ($stateParams.states) {
                for (var j = 0; j < $stateParams.states.length; j++) {
                    vm.preSelectedStates.push($stateParams.states[j]);
                } // for
            } //if

            // is there an id to pre-select ?
            if ($stateParams.taskId) {
                vm.taskId = $stateParams.taskId;
            } // if

            // set overview Service
            vm.overview = service.data.paginationService;

            // clean
            clean();

        } // activate

        // clean
        function clean() {
            tasks = null;
            title = null;
        } // clean

        $scope.$on(SharedAgendaBroadcast.BadgeUpdate, function () {
            refresh();
        });

        function refresh(){
            $state.go($state.current.name, { isToDo: $stateParams.isToDo, all: vm.overview.data.showAll }, { reload: $state.current.name });
        }

        // on destroy
        $scope.$on("$destroy", function () {
            service.clean();
            service = null;
        });


    }
})();
